import React, { useEffect, useState } from "react";
import "./profile.scss";
import User from '../../assets/images/icons/user.png';
import Caution from '../../assets/images/icons/caution.png';
import Arrow from '../../assets/images/icons/chevron.png';
import Telegram from '../../assets/images/icons/telegram.png';

import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../features";
import { getIsNpos, setIsRegistered, setModalSignInUp, wipeLocalStorage } from "../../store/AppSlice";
import { modalTypeEnum } from "../../types/modal";
import { getUserInfo, getUserwallet, requestNposSettings, requestUserSettings } from "../../store/UserSlice";
import Skeleton from "../utils/skeleton/skeleton";
import { Npos } from "./npos/npos";
import { NposInfo } from "../../types/npos";
import { WalletCard } from "./wallet/wallet-card";
import { Slippage } from "./slippage/slippage";
import ToggleButton from "../utils/button-toggle";
import { fetchNposList, getNposList } from "../../store/NposSlice";
import { Button } from "../utils/button/button";
import { getModalReset, setModalReset } from "../../store/ModalSlice";

export const Profile: React.FC = () => {

    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const [nposLoading, setNposLoading]         = useState(true);
    const [tutorialStep, setTutorialStep]       = useState<number>(0);
    const [nposList, setNposLits]               = useState<Array<NposInfo>>([]);

    const info: any                             = useAppSelector(getUserInfo);
    const wallet: any                           = useAppSelector(getUserwallet);
    const isNpos: boolean                       = useAppSelector(getIsNpos);
    const npos: Array<any>                      = useAppSelector(getNposList);

    // modal resetr
    const modalResetStatus: boolean             = useAppSelector(getModalReset);

    useEffect(() => {

        const infoLocal = localStorage.getItem('encryptedData');

        if (info && Object.keys(info).length > 0) {

            const timer = setTimeout(() => {
                setNposLoading(false);
                clearTimeout(timer);
            }, 1000);

            const id = info.id.replace(/-/gi, '');
            const arr: string[] = [];
            for (let i = 0; i < id.length; i++) {
                arr.push(id[i]);
                
            }

            if (!info) dispatch(setModalSignInUp(modalTypeEnum.deviceLogin))

        }

        if (info && Object.keys(info).length === 0 && infoLocal) {
            dispatch(setModalSignInUp(modalTypeEnum.walletLogin));
        }

        if (isNpos) {
            dispatch(requestNposSettings());
        } else {
            dispatch(requestUserSettings());
        }

        setNposLits(npos);

    }, [info, wallet, dispatch, npos]);

    useEffect( () => {
        if (!isNpos) dispatch(fetchNposList());
        //setTutorialStep(1)
    },[])

    useEffect( () => {

        const elements = document.querySelectorAll('[class*="step-"]');
        
        for (let el of elements) {
            if (el.classList.contains(`step-${tutorialStep}`)) {
                el.classList.add('active');
            }
            else {
                el.classList.remove('active');
            }
        }

    },[tutorialStep, setTutorialStep])

    const handleNextTutorialStep = () => {
        setTutorialStep(tutorialStep+1);
    }

    const handleNavigate = (category: string) => {
        if (category === 'register') navigate('/register');
        if (category === 'hash') {
            dispatch(setIsRegistered(true))
            dispatch(setModalSignInUp(modalTypeEnum.register))
        }
    }

    const openTelegram = (link: string) => [
        window.open(`https://telegram.me/${link}`, "_blank")
    ]

    const handleLogoutClick = () => {
        dispatch( wipeLocalStorage() );
        navigate('/');
    }

    const openModalReset = () => {
        console.log(`reset`);
        /*
        dispatch( setModalReset(true) );
        */
    }

    return (
        <>
            <div className="profile-wrapper">
                
                <div className="shadow-tutorial">
                    <button onClick={handleNextTutorialStep}>proximo</button>
                </div>

                <div className="profile-info step-1">
                    <div className="image">
                        <img src={User} alt="" />
                    </div>
                    <div className="info">
                        <h1>
                            {(!info?.nickname && !info?.npos_name) && (
                                <Skeleton variant="text" />
                            )}
                            {info?.nickname && (
                                <span>{info?.nickname}</span>
                            )}
                            {info?.npos_name && (
                                <span>{info?.npos_name}</span>
                            )}
                            {!wallet && <img src={Caution} alt="" />}

                        </h1>
                        <h2>Conta:&nbsp;
                            {(!info?.id && !info?.npos_id)  && (
                                <Skeleton variant="text" />
                            )}
                            {info?.id && (
                                <>
                                    <span>
                                        #{info?.id}
                                    </span>
                                    {info?.npos_id && (
                                        <span className='clear'>
                                            <br/>({info?.npos_id})
                                        </span>
                                    )}
                                </>
                            )}

                        </h2>
                    </div>
                </div>
                
                { !isNpos && (
                    <>
                        
                        {info && Object.keys(info).length === 0 && (
                            <>
                                <p className="text text-warning text-info">
                                    * conta não registrada
                                </p>
                                <div className="notification light" onClick={() => handleNavigate('hash')}>
                                    <img src={Caution} alt="" />
                                    <p>
                                        Antes de qualquer transação é nesessário configurar sua carteira, por favor adicione uma válida.
                                    </p>
                                    <img src={Arrow} alt="" className="arrow-right" />
                                </div>
                            </>
                        )}

                        <span className="divider"></span>

                        <WalletCard />
                        
                        <ToggleButton />

                        { /* <Slippage /> */ }

                        { /*info && Object.keys(info).length > 0 && (
                            <>
                                <div className="notification">
                                    <img src={Caution} alt="" />
                                    <p>
                                        Quer aumentar seu limite? Termine seu registro e aproveite todas as vatangens do APP
                                    </p>
                                    <img src={Arrow} alt="" className="arrow-right" />
                                </div>

                            </>
                        )*/}

                        {info && Object.keys(info).length === 0 && (
                            <Skeleton variant="text" />
                        )}

                        <hr />

                        <div className="share step-5">
                            <h1>
                                NPos
                                <small>Lista de Next Generation point of sale do seu aplicativo!</small>
                            </h1>
                            {nposLoading && (
                                <Skeleton variant="rect" width={100} height={40} />
                            )}
                            {!nposLoading && (
                                <>
                                    <Npos data={nposList}></Npos>
                                    <p>Limite 10 dispositivos ( {nposList.length } conectados )</p>
                                </>
                            )}
                        </div>
                    
                    </>
                )}

                { isNpos && (
                    <>
                        < hr/>
                        <div className="limit">
                            <h1>Unidade NPOS </h1>
                            <p>
                                Essa unidade so tem acesso as funções de venda. So verá os dados dessa unidade e as transações.
                            </p>
                        </div>
                    </>
                )}

                <hr />

                <div className="help step-6">

                    <h1>Suporte</h1>

                    {/* <div className="platform telegram" onClick={() => openTelegram('@TRKBit')}>
                        <img src={Telegram} alt="" />
                        Telegram <b>(@TRKBit)</b>
                    </div> */}

                    <a  href={`mailto:support@trkbit.co?Subject=Swap%20Issue%20${info?.nickname}%20${info.wallet.hash_address}`}>
                    <div className="platform telegram" >
                        <img src={Telegram} alt="" />
                        Email <b>(support@trkbit.co)</b>
                    </div>
                    </a>
                </div>
                
                {/*
                    <button className="btn btn-reset" onClick={openModalReset}>Redefinir senha</button>
                */}

                <Button
                    step='step-7'
                    label="Logout"
                    onClick={() => handleLogoutClick()} 
                    type="in-perfil logout" />

            </div>

            <div className={`modal modal-reset ${modalResetStatus ? 'active' : 'deactivated'}` }>
                    
            </div>
        </>
    )
}